import deepadminApi from '@/api/deepadmin/deepadmin';
import type { AxiosRequestConfig } from 'axios';

//TODO @daniel.henkiel missing api definition
export const getPreferences = (config?: AxiosRequestConfig) =>
  deepadminApi.get('/users/me/profile/', config);
//TODO @daniel.henkiel missing api definition
export const updatePreferences = (
  payload: object,
  config?: AxiosRequestConfig
) => deepadminApi.patch('/users/me/profile/', payload, config);
